import FormData from 'form-data';

import {AddressAmazonType} from 'desktop/types/amazonV2Type';

import {FIELDS, TYPES} from '../../constants';

type AmazonAddressesType = {
    shipping: AddressAmazonType;
    billing: AddressAmazonType;
};

/**
 * Appends fields values to FormData instance and returns it
 * @param {AddressesType} addresses - Received addresses
 * @param {string} formKey - Form key to appending to formData
 * @param {string} affId - affId to appending to formData
 * @returns {FormData} - Returned form data
 */
export const makeAmazonFormData = (
    addresses: AmazonAddressesType,
    formKey: string,
    affId: string,
): FormData => {
    const formData = new FormData();

    TYPES.forEach(type => {
        const address = addresses[type as keyof AmazonAddressesType];

        FIELDS.forEach(([target, field]) => {
            if (!address[field]) return;

            formData.append(`${type}${target}`, address[field]);
        });
    });
    formData.append('affId', affId);
    formData.append('form_key', formKey);

    return formData;
};
